
import { createSSRApp } from 'vue';
import App from './SsrApp.vue';
import { createStore } from './store';
import { createRouter } from './router';
import { elementInView, getObjProperty, getObjPropertyCatchUndefined } from "@utilities/mrVueUtils";
import registerGlobalsSsr from './registerGlobalsSsr';

export async function createApp({ html, computedContentClasses, cmsContentId }) {

  const app = createSSRApp(App, {
    innerHtml: html,
    computedContentClasses,
    cmsContentId,
  });

  const store = createStore();
  const router = createRouter();

  if (process.env.NODE_ENV === 'dev') {
    app.config.devtools = true;
  }

  if (!import.meta.env.SSR) {
    const Sentry = await import('@sentry/browser');

    app.config.errorHandler = function (err, vm, info) {
      //- have to manually log the error to console when using errorHandler
      // eslint-disable-next-line no-console
      console.error(err);

      //- send the error to Sentry for production monitoring
      if (Sentry) {
        Sentry.captureException(err);
        Sentry.setExtra('info', info);
      }
    };
  }

  app.use(store);
  app.use(router);

  app.provide('getObjProperty', getObjProperty);
  app.provide('getObjPropertyCatchUndefined', getObjPropertyCatchUndefined);
  app.provide('elementInView', elementInView);

  registerGlobalsSsr(app);

  return { app, store, router };
}
